import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    searchTemplate: TemplateRef<any>;

    /** Huidige zoekterm, zodat een pagina bij het opbouwen niet op een emit hoeft te wachten. */
    value = '';

    /** Emit uitsluitend bij invoer van de gebruiker. */
    readonly change = new Subject<string>();

    update(val: string) {
        this.value = val ?? '';
        this.change.next(this.value);
    }

    /** Leegmaken bij navigatie. Emit niet: geen pagina hoeft te reageren op een zoekactie
     * die de gebruiker niet heeft gedaan. De volgende pagina leest value zelf. */
    clear() {
        this.value = '';
    }
}
